/**
 * Copy for the warning shown before a RESTRICTED bid is saved to the
 * org-wide library (submission harvest).
 *
 * Wording approved by Kapil on 8 October 2026. Every string the warning
 * shows lives here so a copy change is a one-file change.
 */
export const RESTRICTED_HARVEST_COPY = {
  title: 'Save a restricted bid to the library?',
  body:
    'This bid is restricted to its team. Saving it to the library lets everyone in your organisation, and the AI, see its final response and its result.',
  cancel: 'Cancel',
  confirm: 'Save to library',
} as const
